import React from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import { colors } from '../styles/theme';

function ActionButton({ label, onPress }) {
  return (
    <TouchableOpacity style={styles.actionButton} onPress={onPress}>
      <Text style={styles.actionButtonText}>{label}</Text>
    </TouchableOpacity>
  );
}

export function VenueCardFile({
  venue,
  isSelected,
  onPress,
  onLongPress,
  onView,
  onOpenNotes,
  onOpenEq,
  hasRoomEq,
  onAddPhoto,
  onDeletePhoto,
  isDragging = false,
  userData,
}) {
  return (
    <View
      style={[
        styles.container,
      ]}
    >
      <View style={{
        height: '100%',
        position: 'relative',
        borderRadius: 12,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        overflow: 'hidden',
        elevation: 3,

      }}>

        <View style={styles.imageContainer}>
          {userData?.savedVenueImages?.[venue.id] ? (
            <Image
              source={{ uri: userData?.savedVenueImages?.[venue.id] }}
              style={styles.image}
              resizeMode="cover"
            />
          ) : (
            <View style={styles.placeholder} />
          )}

          {/* Photo upload/delete button overlay */}
          <View style={{
            position: 'absolute',
            top: 5,
            right: 5,
          }}>
            <TouchableOpacity
              style={{
                backgroundColor: 'rgba(255,255,255,0.2)',
                borderRadius: 12,
                padding: 5,
                width: 24,
                height: 24,
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onPress={() => {
                if (userData?.savedVenueImages?.[venue.id]) {
                  onDeletePhoto && onDeletePhoto(venue.id);
                } else {
                  onAddPhoto && onAddPhoto(venue.id);
                }
              }}
            >
              {userData?.savedVenueImages?.[venue.id] ? (
                <Ionicons color="#ffffff" size={12} name="trash" />
              ) : (
                <Ionicons color="#ffffff" size={12} name="camera" />
              )}
            </TouchableOpacity>
          </View>

          <LinearGradient
            colors={['rgba(0,0,0,0)', 'rgba(0,0,0,0.5)']}
            onPress={onPress}
            style={styles.gradientOverlay}
          >
            <View style={styles.contentContainer}>
              <View style={styles.textContainer}>
                <Text style={styles.venueName} numberOfLines={1}>
                  {venue.name}
                </Text>
                {(venue.city || venue.state) ? (
                  <Text style={styles.venueLocation} numberOfLines={1}>
                    {[venue.city, venue.state].filter(Boolean).join(', ')}
                  </Text>
                ) : null}
              </View>
              <View style={styles.buttonsContainer}>
                <ActionButton label="View" onPress={() => onView?.(venue)} />
                <ActionButton label="Notes" onPress={() => onOpenNotes?.(venue)} />
                {hasRoomEq && <ActionButton label="EQ" onPress={() => onOpenEq?.(venue)} />}
              </View>
            </View> 
          </LinearGradient>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    marginBottom: 0,
    borderRadius: 12,
    overflow: 'hidden',
  },
  draggingContainer: {
    opacity: 0.5,
    transform: [{ scale: 0.95 }],
  },
  imageContainer: {
    position: 'relative',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  placeholder: {
    width: '100%',
    height: '100%',
    backgroundColor: '#34495e',
  },
  gradientOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 10,
    paddingTop: 15,
    paddingBottom: 10,
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'space-between',
  },
  contentContainer: {
    flexDirection: 'column',
    gap: 10,
    width: '100%',
  },
  textContainer: {
    flex: 1,
    minWidth: 0,
  },
  buttonsRow: {
    flexDirection: 'row',
    gap: 4,
  },
  venueName: {
    color: '#ffffff',
    fontSize: 10,
    fontFamily: 'VastagoGrotesk',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  venueLocation: {
    color: '#ffffff',
    fontSize: 8,
    fontFamily: 'VastagoGrotesk',
    opacity: 0.9,
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    gap: 4,
  },
  actionButton: {
    backgroundColor: '#666769',
    paddingVertical: 3,
    paddingHorizontal: 4,
    borderRadius: 5,
    alignItems: 'center',
  },
  actionButtonText: {
    color: '#ffffff',
    fontSize: 10,
    fontFamily: 'VastagoGrotesk',
  },
});